import { IStoreState } from "../../../../reducers/types";

export const getOpenDatesModal = (state: IStoreState) =>
  state.vacationRentalAvailability.openDatesModal;
